import EstablishmentChoiceEntryAuctionEntryCompleted from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/AuctionEntry/EstablishmentChoiceEntryAuctionEntryCompleted";
import EstablishmentChoiceEntryAuctionEntryPending from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/AuctionEntry/EstablishmentChoiceEntryAuctionEntryPending";
import EstablishmentChoiceEntryManualEntryCompleted from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryCompleted";
import EstablishmentChoiceEntryManualEntryPending from "../../../components/directivesFormSteps/EstablishmentChoiceEntryFormStep/ManualEntry/EstablishmentChoiceEntryManualEntryPending";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

export const establishmentChoiceEntryOptions: {
  [K in MaintenanceForwardingEstablishmentChoiceEntryKlass]: {
    title: string;
    description: string | undefined;
    components: {
      pending: React.ComponentType;
      completed: React.ComponentType;
    };
  }
} = {
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry]: {
    title: 'Enviar para um único estabelecimento',
    description: 'Defina um Estabelecimentos para aceitar realizar o diagnóstico e orçamento (apenas estabelecimentos homologados para seu Equipamento)',
    components: {
      pending: EstablishmentChoiceEntryManualEntryPending,
      completed: EstablishmentChoiceEntryManualEntryCompleted,
    },
  },
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry]: {
    title: 'Leilão para escolher estabelecimento',
    description: 'Defina quais estabelecimentos estarão aptos para visualizar e enviar lances (apenas estabelecimentos homologados para seu Equipamento)',
    components: {
      pending: EstablishmentChoiceEntryAuctionEntryPending,
      completed: EstablishmentChoiceEntryAuctionEntryCompleted,
    },
  },
}
